import { EntityLinks, Goal, ID } from '@griply/types';
import { getSubGoals } from '@griply/utils';
import { useMemo } from 'react';

export type UseSubGoalsOptions = {
  goals: Goal[];
  links: EntityLinks;
  recursive?: boolean;
};

export const useSubGoals = (
  id: ID | undefined,
  { goals, links, recursive = false }: UseSubGoalsOptions,
): Goal[] =>
  useMemo(
    () => getSubGoals(id, { goals, recursive, links }),
    [goals, id, recursive, links],
  );
